import { useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { Loaders } from "../../../pages/Loaders"
import { toast } from "react-toastify"
import { resetPasswod } from "../../apifile/ApiFiles"


const ResetPasswod = (props) => {
    const [loader, setLoader] = useState(false)
    const [initialVal, setInitialVal] = useState({
        email: ""
    })
    const changeHandler = (e) => {
        const clone = { ...initialVal }
        const value = e.target.value
        const name = e.target.name
        clone[name] = value
        setInitialVal(clone)
    }
    const notify = (updateMassage) => toast(updateMassage);
    const submitData = async () => {
        setLoader(true)
        const clone = { ...initialVal }
        try {
            const res = await resetPasswod(clone)
            console.log(res?.data);
            if (res?.data?.error == false) {
                notify('Password reset link sent successfully!')
                setLoader(false)
                props.onHide()
            } else {
                setLoader(false)
                alert(res?.data?.message)
            }

        } catch (error) {
            setLoader(false)
        }
    }
    return (
        <>
            {loader && <Loaders />}

            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Reset Password
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group   col-lg-12">
                        <label htmlFor="email" className="mb-2">
                            <strong>Email <span style={{ color: 'red' }}>*</span></strong>
                        </label>
                        <input
                            className="form-control"
                            placeholder="Enter Email !"
                            id="email"
                            type="email"
                            name="email"
                            value={initialVal.email}
                            onChange={changeHandler}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='btn-danger' onClick={props.onHide} style={{ width: '200px', height: '50px' }}>Close</Button>
                    <Button variant="primary" disabled={!initialVal?.email} onClick={submitData} style={{ width: '200px', height: '50px' }}>Submit</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ResetPasswod